module.exports = __webpack_public_path__ + "media/images/countryrect/punjab-363e9c935eaeb32c9963812b8fe3e26e.svg";